export default defineNuxtRouteMiddleware(() => {
  if (true) {
    const collectionStore = useCollectionSearchStore();
    const facilityCollections = useFacilityCollections();

    if (collectionStore.collections.length < 1) {
      const fetchCollections = async () => {
        const { data: collections } = await useApiV3().get('/collections');

        if (collections?.items) {
          collectionStore.setCollections(collections.items);
          facilityCollections.setCollections(collections.items);
        }
      }
      fetchCollections();
    } else {
      facilityCollections.setCollections(collectionStore.collections);
    }
  }
});
